import React from 'react';
import { Play, MapPin, Maximize, Building, DollarSign } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4">
            Listen To Their <span className="text-orange-600">Experience With Us</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              {/* Video Thumbnail */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={testimonial.videoThumb}
                  alt={testimonial.project}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <div className="w-16 h-16 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center cursor-pointer hover:bg-orange-600 hover:text-white transition-colors">
                    <Play className="w-8 h-8 text-orange-600 group-hover:text-white" fill="currentColor" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-bold text-gray-900">{testimonial.project}</h3>

                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div className="flex items-center space-x-2 text-gray-600">
                    <MapPin className="w-4 h-4 text-orange-600" />
                    <span>{testimonial.location}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Maximize className="w-4 h-4 text-orange-600" />
                    <span>{testimonial.area}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <Building className="w-4 h-4 text-orange-600" />
                    <span>{testimonial.floors}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <DollarSign className="w-4 h-4 text-orange-600" />
                    <span>{testimonial.price}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;